export default "__VITE_ASSET__CPuSobSr__"